import React from 'react'

import useStyles from './styles'

const QueueSkeletonV2 = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.topArea}>
        <div className={classes.avatar} />

        <div className={classes.topText} />
      </div>

      <div className={classes.bottomArea} />
    </div>
  )
}

export default QueueSkeletonV2
